import { SESSION_STATUS } from './session';

export const GATE_VIEW = {
  LOADING: 'loading',
  REDIRECT_TO_LOGIN: 'redirectToLogin',
  ACCESS_DENIED: 'accessDenied',
  UNAVAILABLE: 'unavailable',
  CONTENT: 'content',
};

// What the Auth Gate shows for a Portal's page, given the current session. A
// session settled for another Portal says nothing about this one yet.
export function getGateView(sessionState, portal) {
  const { status } = sessionState;

  if (status === SESSION_STATUS.SIGNED_OUT) {
    return GATE_VIEW.REDIRECT_TO_LOGIN;
  }

  if (
    status === SESSION_STATUS.INITIALIZING ||
    sessionState.portal !== portal
  ) {
    return GATE_VIEW.LOADING;
  }

  if (status === SESSION_STATUS.READY) {
    return GATE_VIEW.CONTENT;
  }

  return status === SESSION_STATUS.DENIED
    ? GATE_VIEW.ACCESS_DENIED
    : GATE_VIEW.UNAVAILABLE;
}
